export default {
  existing_documents: {
    description:
      'You have already uploaded the following documents. Select one and press send, or upload a new document instead.',
    sides: {
      front: 'Front',
      back: 'Back',
    },
    created_at: 'Uploaded: {{date}}',
    expires_at: 'Expires: {{date}}',
  },
  document_types: {
    owner_document: 'Owner identity document',
    business_document: 'Business document',
  },
  form: {
    document_type: {
      label: 'Proof of business document',
      placeholder: 'Select document type',
      options: {
        vat_registration: 'VAT Registration',
        trade_registration: 'Trade registration',
        trade_license: 'Trade license',
        commercial_register_extract: 'Commercial register extract',
        financial_statements: 'Financial statements',
        other: 'Other',
      },
    },
    front: {
      label: 'Document front',
    },
    back: {
      label: 'Document back (optional for some documents)',
    },
    expires_at: {
      label: 'Document expiry date',
      placeholder: 'Select expiry date',
    },
  },
  buttons: {
    select_file: 'Select file',
    next: 'Next',
    back: 'Back',
    send: 'Send',
    upload_new: 'Upload new document',
    use_existing: 'Use an uploaded document',
  },
};
